export { createDiscreteApi } from './src/discrete';
